import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState(null, "", "/account");
        nav("/account", { state: { user: data.user } });
      } catch (e) {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-white/10 border-t-[#FF4433] rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-kyro-mute">Signing you in securely...</p>
      </div>
    </div>
  );
}
